import { createFileRoute } from '@tanstack/react-router'
import PricingWidget, {
  PricingPlan,
} from '@/src/components/pricing/PricingWidget'
import plansDataRaw from '@/src/components/pricing/plans.json'
import { useTranslation } from '@/src/i18n/client'

// Convert buttonType to the correct type
const plans: PricingPlan[] = (plansDataRaw as any[]).map((plan) => ({
  ...plan,
  buttonType: plan.buttonType as 'button' | 'form' | 'link',
}))

export const Route = createFileRoute('/_static/pricing')({
  component: PricingPage,
})

function PricingPage() {
  const { t } = useTranslation('static')
  return (
    <div className="container mx-auto max-w-7xl py-8">
      <div className="mb-8 text-center">
        <h2 className="text-3xl font-bold mb-1">{t('pricing.title')}</h2>
      </div>
      <PricingWidget plans={plans} />
    </div>
  )
}
